import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfigCheckerComponent } from './components/config-checker/config-checker.component';
import { ConfigCheckerSettingsComponent } from './components/config-checker-settings/config-checker-settings.component';
import { ConfigCheckerAuthComponent } from './components/config-checker-auth/config-checker-auth.component';
import {HomePageModule} from '../pages/home/home.module';
import {IonicModule} from '@ionic/angular';
import {FormsModule} from '@angular/forms';

@NgModule({
  declarations: [ConfigCheckerComponent, ConfigCheckerSettingsComponent, ConfigCheckerAuthComponent],
  imports: [CommonModule, HomePageModule, IonicModule, FormsModule],
  exports: [ConfigCheckerComponent, ConfigCheckerSettingsComponent, ConfigCheckerAuthComponent]
})
export class ConfigCheckerModule {}
